import React, { useEffect } from 'react';
import { SypacInput, SypacText } from '@sypac/component-library-react';
import { DatePicker } from '../../../../components/DatePicker/DatePicker';
import { T, useTranslate } from '@tolgee/react';
import dayjs from 'dayjs';
import { SectionProps } from '../addNewContract.interface';

const ContractValiditySection: React.FC<SectionProps> = ({ formik }) => {
	const { t } = useTranslate();

	useEffect(() => {
		const { dateFrom, dateTo } = formik.values as {
			dateFrom: string;
			dateTo: string;
		};
		if (dateFrom && dateTo) {
			const from = dayjs(dateFrom).startOf('day');
			const to = dayjs(dateTo).startOf('day');
			if (to.isBefore(from)) {
				formik.setFieldValue('dateTo', dateFrom);
			}
		}
	}, [formik.values.dateFrom]); // eslint-disable-line

	useEffect(() => {
		const { dateFrom, dateTo } = formik.values as {
			dateFrom: string;
			dateTo: string;
		};
		if (dateFrom && dateTo) {
			const from = dayjs(dateFrom).startOf('day');
			const to = dayjs(dateTo).startOf('day');
			if (from.isAfter(to)) {
				formik.setFieldValue('dateFrom', dateTo);
			}
		}
	}, [formik.values.dateTo]); // eslint-disable-line

	return (
		<>
			<SypacText variant="body-regular-medium">
				<p className="text-gray-40 text-[14px] leading-[16px] mx-3">
					<T keyName="adminContracts.contractDuration">Contract duration</T>
				</p>
			</SypacText>

			<div className="flex gap-3 mx-3">
				<div className="w-full h-fit flex justify-center bg-alabaster border border-dashed border-gray-10 rounded-10 p-[10px]">
					<SypacInput
						error={!!(formik.touched.dateFrom && formik.errors.dateFrom)}
						className="w-full"
					>
						<SypacText className="mb-2" variant="overline-normal-large">
							<p>
								<T keyName="adminContracts.dateFrom">Date from</T>{' '}
								<span className="text-red">*</span>
							</p>
						</SypacText>

						<DatePicker
							min={dayjs().format('YYYY-MM-DD')}
							max={
								formik?.values.dateTo
									? dayjs(formik.values.dateTo).format('YYYY-MM-DD')
									: undefined
							}
							value={formik?.values.dateFrom?.toString?.() || ''}
							onChange={(date) => formik.setFieldValue('dateFrom', date)}
							placeholder={t('adminContracts.selectDate', 'Select date')}
							allowOtherMonthSelection
							error={!!(formik.touched.dateFrom && formik.errors.dateFrom)}
						/>
						{formik.touched.dateFrom && formik.errors.dateFrom ? (
							<span className="text-xs text-red-orange mt-[2px]">
								{formik.errors.dateFrom}
							</span>
						) : null}
					</SypacInput>
				</div>

				<div className="w-full h-fit flex justify-center bg-alabaster border border-dashed border-gray-10 rounded-10 p-[10px]">
					<SypacInput
						error={!!(formik.touched.dateTo && formik.errors.dateTo)}
						className="w-full"
					>
						<SypacText className="mb-2" variant="overline-normal-large">
							<p>
								<T keyName="adminContracts.dateTo">Date to</T>{' '}
								<span className="text-red">*</span>
							</p>
						</SypacText>

						<DatePicker
							min={
								(formik?.values.dateFrom && String(formik.values.dateFrom)) ||
								dayjs().format('YYYY-MM-DD')
							}
							value={formik?.values.dateTo?.toString?.() || ''}
							onChange={(date) => formik.setFieldValue('dateTo', date)}
							placeholder={t('adminContracts.selectDate', 'Select date')}
							allowOtherMonthSelection
							error={!!(formik.touched.dateTo && formik.errors.dateTo)}
						/>
						{formik.touched.dateTo && formik.errors.dateTo ? (
							<span className="text-xs text-red-orange mt-[2px]">
								{formik.errors.dateTo}
							</span>
						) : null}
					</SypacInput>
				</div>
			</div>
		</>
	);
};

export default ContractValiditySection;
